import React, { useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
            setMessage('Password reset link sent to your email.');
        } catch (error) {
            setError('Error sending password reset link. Please try again.');
            console.error('Error:', error.response ? error.response.data : error.message);
        }
    };

    return (
        <Container>
            <FormWrapper>
                <h2>Forgot Password</h2>
                <Form onSubmit={handleSubmit}>
                    <FormField>
                        <Label>Email:</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </FormField>
                    {message && <Message>{message}</Message>}
                    {error && <Error>{error}</Error>}
                    <Button type="submit">Send Reset Link</Button>
                </Form>
            </FormWrapper>
        </Container>
    );
};

export default ForgotPassword;

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f7f9fc;
`;

const FormWrapper = styled.div`
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 100%;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
`;

const FormField = styled.div`
    margin-bottom: 20px;
`;

const Label = styled.label`
    margin-bottom: 10px;
    font-weight: bold;
`;

const Input = styled.input`
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
`;

const Button = styled.button`
    padding: 10px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;

    &:hover {
        background: #0056b3;
    }
`;

const Message = styled.p`
    color: green;
    margin-bottom: 20px;
`;

const Error = styled.p`
    color: red;
    margin-bottom: 20px;
`;
